import React from 'react';
import { PHONE_ACTION_BAR_PINNED, DESKTOP_ACTION_BAR_PINNED } from '../../constants/overlayLayers';

/**
 * THE phone (below `md`) sticky action bar (owner, 2026-10-03): while an
 * expanded order / hire / gag panel has unsaved changes, its EXISTING Save /
 * Discard buttons pin to the viewport bottom above the nav; the New Order
 * form pins Submit + its total the same way. Callers: `OrderForm.js` (order
 * and hire panels, the order page, New Order), `gags/GagDetailPanel.js` and
 * `teams/TaskEditor.js` inline — the last two render it ONLY while dirty and
 * pin it on a phone only (2026-10-07: from `md` each has a header pair at its
 * top instead, or the gag the desktop Table's row bar). Orders/hires still pin
 * at every width (`OrderForm`'s `desktopPinned`, owner 2026-10-03).
 *
 * It wraps the caller's own button row — the SAME buttons and handlers, never
 * a copy. `pinned` false (or `md` and up): the row renders in flow with the
 * caller's `className` alone, exactly as before. `pinned` true adds only
 * `max-md:` classes plus a phone-only spacer so the bar never hides the end
 * of the panel. 🪤 `position: fixed` is trapped by a transformed/filtered
 * ancestor — measured clear on every caller at 375 (2026-10-03).
 *
 * Placement (owner, 2026-10-05: "centered but even spacing so they are not too
 * close together on mobile"): on a phone the buttons are spaced EVENLY across
 * the full-width bar (`justify-evenly`); from `md` the bar floats CENTRED on the
 * page area beside the sidebar, not the window (`DESKTOP_ACTION_BAR_PINNED`).
 */
// fill (opt-in, timesheets 2026-10-27 — owner: "full width buttons look better ... when its the only option"):
// pinned on a phone, every button grows to share the bar's width (one button = full width).
export default function PhoneActionBar({ pinned = false, desktopPinned = false, fill = false, className = '', testId, children }) {
  return (
    <>
      <div
        className={[className, pinned ? PHONE_ACTION_BAR_PINNED : '', pinned && fill ? 'max-md:[&_button]:flex-1 max-md:[&_button]:justify-center max-md:[&_button]:text-center' : '', pinned && desktopPinned ? DESKTOP_ACTION_BAR_PINNED : ''].filter(Boolean).join(' ')}
        data-testid={testId}
        data-phone-pinned={pinned ? 'true' : undefined}
      >
        {children}
      </div>
      {pinned ? <div aria-hidden="true" className={desktopPinned ? 'h-16' : 'md:hidden h-16'} data-testid={testId ? `${testId}-spacer` : undefined} /> : null}
    </>
  );
}
